import { HttpClientContext } from '@shared/http/http-client.context';
import React from 'react';

export const useHttpClient = () => React.useContext(HttpClientContext);
